<template>
  <div>
    <draggable
      v-model="local_value"
      class="drag-area synaplus-cosmo-scroll-higher-720"
      group="file-selection-type"
      handle=".file-selection-type-handle"
      :sort="editing_nb == -1"
    >
      <file-selection-element
        v-for="(val, index) in local_value"
        v-bind="file_selection_element_bindings(false, val, index)[0]"
        v-on="file_selection_element_bindings(false, val, index)[1]"
        class="mt-2 hand-pointer file-selection-type-handle"
      />
    </draggable>

    <file-selection-element
      v-model="new_file_selection_entry"
      v-bind="
        file_selection_element_bindings(true, new_file_selection_entry)[0]
      "
      v-on="file_selection_element_bindings(true, new_file_selection_entry)[1]"
      class="mt-4"
    />
  </div>
</template>

<script>
import $ from 'jquery'
import _ from 'lodash'
import Vue from 'vue'
import moment from 'moment'
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import draggable from 'vuedraggable'

import { mapGetters } from 'vuex'

import {
  extended_dict_getValue,
  formatted_integer_with_thousand_spaces,
  formatted_moment_localized,
} from '@/utils.js'

import { FileInfosEntity } from '@/components/object_model.js'

import { global_brick_mixin } from '@/components/mixin.js'

import FilepathSelector from '@/components/filepath_selector.vue'
import FileUploader from '@/components/file_uploader.vue'

import FileSelectionElement from '@/components/file_selection_element.vue'

// *****************************************************************************

export default {
  name: 'BrickFileSubcomponentFileSelection',
  components: {
    'vue-dropzone': vue2Dropzone,
    draggable,
    FilepathSelector,
    FileUploader,
    FileSelectionElement,
  },
  mixins: [global_brick_mixin],
  props: ['value'],
  data() {
    const did = 'dropzone' + _.uniqueId()
    const idref = '#' + did
    return {
      local_value: [],
      editing_nb: -1,
      new_file_selection_entry: new FileInfosEntity(),
    }
  },

  computed: {
    rawfile_configured() {
      return (
        this.cur_brick.uploaded_rawfile_uid !== -1 ||
        !_.isNull(this.cur_brick.generic_sourcefilepath)
      )
    },
  },
  watch: {
    value: {
      immediate: true,
      async handler(nv, ov) {
        if (!_.isEqual(nv, this.local_value)) {
          this.local_value = nv
        }
      },
    },

    local_value: {
      immediate: true,
      async handler(nv, ov) {
        if (!_.isEqual(nv, this.value)) {
          this.$emit('input', nv)
        }
      },
    },
  },
  beforeMount() {
    this.fetch_collections(['rawfiles'])
  },
  methods: {
    remove_potential_duplicate(index, entry) {
      let temp = _.cloneDeep(this.local_value)
      temp.splice(index, 1)

      let duplicate_index = _.findIndex(temp, x => _.isEqual(x, entry))

      if (duplicate_index !== -1) {
        if (duplicate_index >= index) {
          duplicate_index += 1
        }
        this.local_value.splice(duplicate_index, 1)
      }

      this.editing_nb = -1
    },

    add_new_file_element(entry) {
      if (!_.find(this.local_value, x => _.isEqual(x, entry))) {
        this.local_value.push(entry)
      }

      this.new_file_selection_entry = new FileInfosEntity()
      this.editing_nb = -1
    },

    delete_file_element(index) {
      this.local_value.splice(index, 1)
      this.editing_nb = -1
    },

    validate_file_element_edition(index, entry) {
      Vue.set(this.local_value, index, entry)
      this.remove_potential_duplicate(index, entry)
    },

    file_selection_element_bindings(is_new_entry, entry, index) {
      let is_new_file_element = is_new_entry
      let in_edition = is_new_entry ? true : this.editing_nb == index

      let bind = {
        value: entry,
        is_new_file_element,
        in_edition,
        project_id: this.project_id,
        brick_id: this.brick_id,
      }

      let on = is_new_entry
        ? {
            input: this.add_new_file_element.bind(this),
          }
        : {
            start_editing: () => {
              this.editing_nb = index
            },
            delete: () => this.delete_file_element(index),
            input: val => {
              this.validate_file_element_edition(index, val)
            },
          }

      let res = [bind, on]

      return res
    },
  },
}
</script>
